/**
 * Front door service
 * The front door service API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AvailabilityDto } from './availabilityDto';


export interface WorkScheduleDto { 
    id: string;
    name: string;
    timezone: string;
    /**
     * The type of work schedule
     */
    workScheduleType: WorkScheduleDto.WorkScheduleTypeEnum;
    availabilities?: Array<AvailabilityDto>;
}
export namespace WorkScheduleDto {
    export type WorkScheduleTypeEnum = 'virtual' | 'physical' | 'interpretation-service';
    export const WorkScheduleTypeEnum = {
        Virtual: 'virtual' as WorkScheduleTypeEnum,
        Physical: 'physical' as WorkScheduleTypeEnum,
        InterpretationService: 'interpretation-service' as WorkScheduleTypeEnum
    };
}


